import { VStack } from "@chakra-ui/react"
import {
  constructUrl,
  getStepUrl
} from "@pathwright/web/src/modules/utils/urls"
import { connect } from "lib/core/store"
import PropTypes from "prop-types"
import { getDiscussionListHandlers } from "../discussion/utils"

const StepDiscussionContainer = ({
  step,
  offering,
  resource,
  canStartDiscussion,
  createTypes,
  updateTypes,
  children
}) => {
  // ensure props exist
  if (resource && offering && step) {
    const context = {
      resource_id: resource.id,
      cohort_id: offering.id,
      step_id: step.sync_source_id
    }

    const baseRoute = constructUrl(
      getStepUrl(resource.slug, offering.id, step.sync_source_id),
      "discussion"
    )

    const { onStartDiscussion, onSelectDiscussion } = getDiscussionListHandlers(
      {
        canStartDiscussion,
        baseRoute,
        createTypes,
        updateTypes: offering.is_curriculum ? createTypes : updateTypes
      }
    )

    return (
      <VStack w="100%" maxW="700px" m="0 auto" spacing={4}>
        {children({
          context,
          onStartDiscussion,
          onSelectDiscussion
        })}
      </VStack>
    )
  }

  return null
}

StepDiscussionContainer.displayName = "StepDiscussionContainer"

StepDiscussionContainer.propTypes = {
  step: PropTypes.object.isRequired,
  children: PropTypes.func.isRequired
}

export default connect(
  StepDiscussionContainer,
  "resource",
  (state, ownProps) => {
    const { resource, offering } = state.resourceStore.state
    return {
      ...ownProps,
      resource,
      offering
    }
  },
  false
)
